import axios from "axios";

export const putCatchReportSubmit = async (data: any) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/CatchReport/submit`,
      data
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
